module.exports = __webpack_public_path__ + "static/media/logo.4adad411.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/logo.svg
// module id = 1834
// module chunks = 0